// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._kYNmf {
  max-width: 480px;
  width: 100%;
}

.NM5S4J {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4, 32px);
  text-align: center;
  animation: WiMqug 0.3s ease-out 0.1s both;
}

.mQAsy_ {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-md, 16px);
  line-height: 1.5;
  color: var(--text-neutral-dark, #333333);
  margin: 0;
}

.WN9pVi {
  display: flex;
  justify-content: center;
  width: 100%;
}

.FnUrQS {
  min-width: 200px;
}

@media (max-width: 768px) {
  ._kYNmf {
    max-width: 90vw;
    margin: var(--spacing-2, 16px);
  }

  .NM5S4J {
    gap: var(--spacing-3, 24px);
  }

  .mQAsy_ {
    font-size: var(--font-size-sm, 14px);
  }

  .FnUrQS {
    min-width: 180px;
  }
}

@keyframes WiMqug {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/SessionExpiredModal/SessionExpiredModal.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAgD;AAClD;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,oCAAoC;EACpC,gBAAgB;EAChB,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".sessionExpiredModal {\n  max-width: 480px;\n  width: 100%;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-4, 32px);\n  text-align: center;\n  animation: contentFadeIn 0.3s ease-out 0.1s both;\n}\n\n.message {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-md, 16px);\n  line-height: 1.5;\n  color: var(--text-neutral-dark, #333333);\n  margin: 0;\n}\n\n.actions {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.loginButton {\n  min-width: 200px;\n}\n\n@media (max-width: 768px) {\n  .sessionExpiredModal {\n    max-width: 90vw;\n    margin: var(--spacing-2, 16px);\n  }\n\n  .content {\n    gap: var(--spacing-3, 24px);\n  }\n\n  .message {\n    font-size: var(--font-size-sm, 14px);\n  }\n\n  .loginButton {\n    min-width: 180px;\n  }\n}\n\n@keyframes contentFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sessionExpiredModal": `_kYNmf`,
	"content": `NM5S4J`,
	"contentFadeIn": `WiMqug`,
	"message": `mQAsy_`,
	"actions": `WN9pVi`,
	"loginButton": `FnUrQS`
};
module.exports = ___CSS_LOADER_EXPORT___;
